import { API } from "../../../utils";
import qs from "qs";

export const getSegments = async (query, pagination) => {
  const { pageIndex, pageSize } = pagination;
  const url = `segments?page=${pageIndex}&per_page=${pageSize}`;
  const res = await API.get(url, query);
  return res.data;
};

export const getSegmentCustomersApi = async (query, pagination, segmentId) => {
  const { pageIndex, pageSize } = pagination;
  const url = `segments/${segmentId}/customers?page=${pageIndex}&per_page=${pageSize}`;
  const res = await API.get(url, query);
  return res.data;
};

export const getSegmentReferencesApi = async (query, pagination, segmentId) => {
  const { pageIndex, pageSize } = pagination;
  const url = `segments/${segmentId}/references?page=${pageIndex}&per_page=${pageSize}`;
  const res = await API.get(url, query);
  return res.data;
};

export const getSegmentationBoot = async () => {
  const res = await API.get("segmentation_boot");
  return res.data;
};

export const getSegmentById = async (id) => {
  const res = await API.get(`segments/${id}`);
  return res.data;
};

export const createSegment = async (payload) => {
  const res = await API.post("segments", payload);
  return res.data;
};

export const updateSegment = async (id, payload) => {
  const res = await API.put(`segments/${id}`, payload);
  return res.data;
};

export const searchSegmentCustomers = async (payload, params) => {
  const res = await API.post("segments/search", payload, {
    params,
    paramsSerializer: (p) => qs.stringify(p),
  });
  return res.data;
};

export const rerunSegment = async (id) => {
  const res = await API.post(`segments/${id}/rerun`);
  return res.data;
};

export const exportSegmentCustomers = async (segmentId) => {
  const res = await API.get(`segments/${segmentId}/export`);
  return res.data;
};

export const deleteSegmentApi = async (id) => {
  const res = await API.delete(`segments/${id}`);
  return res.data;
};
